
const modalContainer = document.getElementById('modal-container');

const startModalCloseTimer = async (modalId) => {
    const modal = document.getElementById("modal_" + modalId);
    const timer = modal.querySelector(".timer");
    
    // Wrap classList.add in setTimeout in order to trigger animation
    setTimeout(() => {
        timer.classList.add("max-w-0");
        
        setTimeout(() => {
            modal.remove();
        }, 5000)
    }, 0);
}

const openModal = (text, color = "green") => {
    const modalId = crypto.randomUUID();
    const modalHtml = `
        <div id="modal_${modalId}" class="w-full bg-${color}-300 border border-${color}-700 text-${color}-700 rounded-lg p-6 flex flex-row justify-between items-center relative overflow-hidden mt-4 sm:mt-8">
            <span>${text}</span>
            <svg class="cursor-pointer opacity-100 hover:opacity-50" width="20" height="20" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="${modalId}" click="closeModal">
                <path d="M22.5 7.5L7.5 22.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>
                <path d="M22.5 22.5L7.5 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>
            </svg>
            <span class="timer absolute left-0 bottom-0 w-full h-[3px] bg-green-500 max-w-full transition-all duration-[5000ms]"></span>
        </div>
    `
    modalContainer.innerHTML += modalHtml;
    startModalCloseTimer(modalId);
}